<template>
  <v-container>
    <div>
      <template>
        <v-dialog
          v-model="dialog"
          width="600"
          @click:outside="closeModal"
          :retain-focus="false"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                {{ $t("groupForm.createGroup") }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="black--text">
              <v-row class="mt-5">
                <v-col cols="12">
                  <label class="">
                    {{ $t("groupForm.groupName") }}
                  </label>
                  <v-text-field
                    type="text"
                    outlined
                    dense
                    placeholder="Select Name"
                    v-model="group.name"
                    :error-messages="groupNameError"
                  >
                  </v-text-field>

                  <!-- <label class="">Type of Animal</label>
                                    <v-select outlined dense placeholder="Select Type" :items="speciesTypes" item-text="name" item-value="id" v-model="group.animalTypeId"></v-select>

                                    <label class="">Animal Category</label>
                                    <v-select outlined dense placeholder="Select Category" :items="animalCategories" item-text="name" item-value="id" v-model="group.animalCategoryId"></v-select>

                                    <label class="">Body Weight</label>
                                    <v-select outlined dense placeholder="Select Weight" :items="weights" v-model="group.bodyWeight"></v-select> -->

                  <!-- <label class="">Feed Name</label>
                                    <v-select outlined dense placeholder="Select Name"></v-select> -->

                  <label class="">
                    {{ $t("groupForm.groupStatus") }}
                  </label>
                  <v-select
                    outlined
                    dense
                    placeholder="Active"
                    :items="statuses"
                    v-model="group.status"
                  ></v-select>
                </v-col>
              </v-row>
              <v-card-actions class="mt-10" style="padding-right: 0">
                <v-spacer></v-spacer>
                <v-btn
                  @click="closeModal"
                  outlined
                  class="mr-2 px-5"
                  right
                  height="44"
                  depressed
                  color="primary"
                >
                  {{ $t("cancel") }}
                </v-btn>
                <v-btn
                  @click="submit"
                  right
                  height="44"
                  color="primary"
                  class="px-5"
                >
                  {{ $t("submit") }}
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
    </div>
  </v-container>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";

import gql from "graphql-tag";

export default {
  computed: {
    dialog() {
      return this.dialogI;
    },
  },
  data() {
    return {
      groupNameError: "",
      group: { name: null, status: "Active" },
      statuses: ["Active", "Inactive"],
      weights: [
        "250kg-300kg",
        "300kg-350kg",
        "400kg-450kg",
        "500kg-550kg",
        "600kg-650kg",
      ],
    };
  },
  props: {
    animalCategories: {
      type: Array,
      required: true,
    },

    newGroupName: {
      required: false,
      type: String,
    },

    speciesTypes: {
      type: Array,
      required: true,
    },

    dialogI: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("closeDialog");
    },
    async submit() {
      if (!this.group.name) {
        this.groupNameError = "Group Name is required.";
        return;
      }
      this.groupNameError = "";
      await this.$apollo
        .mutate({
          mutation: gql`
            mutation createGroup($createGroupInput: CreateGroupInput!) {
              createGroup(createGroupInput: $createGroupInput) {
                id
              }
            }
          `,
          // Parameters
          variables: {
            createGroupInput: {
              name: this.group.name,
              animalTypeId: this.group.animalTypeId
                ? parseInt(this.group.animalTypeId)
                : null,
              animalCategoryId: this.group.animalCategoryId
                ? parseInt(this.group.animalCategoryId)
                : null,
              bodyWeight: this.group.bodyWeight,
              status: this.group.status.toLowerCase(),
            },
          },
        })
        .then(response => {
          if (response.data.createGroup) {
            this.$notify({
              title: "Group Added Successfully",
              text: "", //res.message,
              type: "success",
            });

            this.$emit("group:created", response.data.createGroup);
          }
        })
        .catch(() => {
          this.$notify({
            title: "Group Not Added",
            text: "",
            type: "error",
          });
        })
        .finally(() => {
          this.$emit("closeDialog");
        });
    },
  },

  mounted() {
    if (this.newGroupName) {
      this.group.name = this.newGroupName;
    }
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
.border {
  border: 2px solid;
  border-color: #dae1ec;
}

.v-tab {
  text-transform: none !important;
}
</style>
